import API from "../api/axios";

// ─── Get All Followups ───
export const getAllFollowups = () => {
   return API.get("/followups-all");
};

// ─── Get Followups by Lead ───
export const getLeadFollowups = (leadId) => {
   return API.get(`/followups/${leadId}`);
};

// ─── Create Followup ───
export const createFollowup = (data) => {
   return API.post("/followups", data);
};

// ─── Update Followup ───
export const updateFollowup = (id, data) => {
   return API.put(`/followups/${id}`, data);
};

// ─── Delete Followup ───
export const deleteFollowup = (id) => {
   return API.delete(`/followups/${id}`);
};